export const compareToTimeUnit = {
    '1d': [1, 'd'],
    '1w': [1, 'w'],
};
//# sourceMappingURL=compare-to.enum.js.map